var render = function render(){
  var _vm$otpValidationMess;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    ref: "otpModal",
    staticClass: "add-member-modal",
    attrs: {
      "id": "validate_otp",
      "centered": true,
      "no-close-on-backdrop": "",
      "size": "sm",
      "title": `Validate ${_vm.identifierTypeText} via OTP`,
      "hide-footer": true
    },
    on: {
      "hidden": _vm.closeModal,
      "shown": _vm.resetValidationState
    },
    model: {
      value: _vm.isOpen,
      callback: function ($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "verifyOTPContent mb-4"
  }, [_c('div', {
    staticClass: "header-content mb-4"
  }, [_c('h6', {
    staticClass: "mb-1"
  }, [_vm._v("Verify OTP")]), _c('div', {
    staticClass: "text-muted mb-2"
  }, [_vm._v(" Validate your " + _vm._s(_vm.identifierTypeText) + " via OTP "), _c('br'), _vm._v(" OTP has been sent to "), _c('strong', {
    staticClass: "text-dark"
  }, [_vm._v(_vm._s(_vm.identifier))])])]), _c('div', {
    staticClass: "OtpWrapper"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Please enter the 6 digit OTP:")]), _c('div', {
    staticClass: "d-flex mb-4 otp-inputs-wrapper align-items-center pb-2"
  }, _vm._l(_vm.otpDigits, function (digit, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.otpDigits[index],
        expression: "otpDigits[index]",
        modifiers: {
          "number": true
        }
      }],
      key: index,
      ref: "otpInputs",
      refInFor: true,
      staticClass: "form-control otp-input",
      attrs: {
        "maxlength": "1",
        "min": "0",
        "max": "9",
        "disabled": _vm.otpVerified
      },
      domProps: {
        "value": _vm.otpDigits[index]
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.otpDigits, index, _vm._n($event.target.value));
        }, function ($event) {
          return _vm.handleOtpInput(index, $event);
        }],
        "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) return null;
          return _vm.handleOtpDelete(index, $event);
        }, function ($event) {
          return _vm.preventNonNumeric($event);
        }],
        "paste": function ($event) {
          return _vm.handlePaste($event);
        },
        "blur": function ($event) {
          return _vm.$forceUpdate();
        }
      }
    });
  }), 0)])]), _c('div', {
    staticClass: "btn-wrapper mt-3 d-flex flex-column gap-16"
  }, [_c('button', {
    staticClass: "primaryBtn w-100",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isOtpComplete || _vm.otpVerificationInProgress || _vm.otpVerified
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.verifyOtp.apply(null, arguments);
      }
    }
  }, [_vm.otpVerificationInProgress ? _c('span', [_c('b-spinner', {
    attrs: {
      "small": "",
      "type": "grow"
    }
  }), _vm._v(" Verifying...")], 1) : _vm.otpVerified ? _c('span', [_vm._v("Verified")]) : _c('span', [_vm._v("Verify OTP")])]), (_vm$otpValidationMess = _vm.otpValidationMessage) !== null && _vm$otpValidationMess !== void 0 && _vm$otpValidationMess.message && _vm.otpAttempted ? _c('div', {
    staticClass: "otp-message-container mt-2 form-group"
  }, [_c('div', {
    class: ['validate-message', _vm.otpValidationMessage.type]
  }, [_c('div', {
    class: ['message-indicator', `${_vm.otpValidationMessage.type}-indicator`]
  }), _c('span', {
    staticClass: "message-text"
  }, [_c('strong', {
    class: `${_vm.otpValidationMessage.type}-text`
  }, [_vm._v(_vm._s(_vm.otpValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.otpValidationMessage.message) + " ")])])]) : _vm._e(), _c('div', {
    staticClass: "d-flex align-items-center gap-16 flex-column flex-md-row"
  }, [_c('button', {
    staticClass: "btn-secondary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "primaryBtn w-100 border-0",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSaveChanges
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" Save Changes ")])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }